var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 12.1673V13.834C1.33334 14.276 1.50894 14.6999 1.8215 15.0125C2.13406 15.3251 2.55798 15.5007 3.00001 15.5007H13C13.442 15.5007 13.866 15.3251 14.1785 15.0125C14.4911 14.6999 14.6667 14.276 14.6667 13.834V12.1673M3.83334 7.16732L8.00001 11.334M8.00001 11.334L12.1667 7.16732M8.00001 11.334V1.33398",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e875ae0b5c1d9e9d7ba0a951bff1e388.svg";
export { ForwardRef as ReactComponent };